// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__JwJUA","paginationBtn":"pagination_paginationBtn__CNisL","activeLi":"pagination_activeLi__4b81Z","modal":"pagination_modal__TefQ7"};